import styled from '@emotion/styled';

import { largeScreen, mediaQueries } from '@app/styles/theme/breakpoints';
import type { GridBreakpoint } from '@app/styles/theme/grid';
import grid, { GRID_BREAKPOINT_LARGE_SCREEN } from '@app/styles/theme/grid';

interface GridProps {
  fixedWidth?: boolean;
  children: React.ReactNode;
}

const Grid = ({ children, fixedWidth = false }: GridProps) => {
  return <GridStyle fixedWidth={fixedWidth}>{children}</GridStyle>;
};

const GridStyle = styled.div<{ fixedWidth?: boolean }>((props) => {
  const setGridTemplate = (columns, columnsWidth) => {
    return Array.from(Array(columns))
      .map(() => `minmax(${columnsWidth}, 1fr)`)
      .join(' ');
  };

  const setGridStyle = ({
    name,
    columnGap,
    outerMargin,
    columns,
    columnsWidth,
  }: GridBreakpoint) => {
    const isFixedWidth =
      name === GRID_BREAKPOINT_LARGE_SCREEN && props.fixedWidth;

    return {
      columnGap: columnGap,
      marginLeft: isFixedWidth ? 'auto' : outerMargin,
      marginRight: isFixedWidth ? 'auto' : outerMargin,
      gridTemplateColumns: setGridTemplate(columns, columnsWidth),
      ...(isFixedWidth && { width: largeScreen }),
    };
  };

  const style = {
    display: 'grid',
    ...setGridStyle(grid[0]),
  };

  mediaQueries.forEach((mq, index) => {
    Object.assign(style, {
      [mq]: {
        ...setGridStyle(props.theme.grid[index]),
      },
    });
  });

  return style;
});

export default Grid;
